module.exports = __webpack_public_path__ + "img/logo.1cf5f1fb.jpg";